<template>
  <div>
    <div class="form-group">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="school-box" v-model="showSchools">
        <label class="form-check-label" for="school-box">Schools</label>
      </div>
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="restaurant-box" v-model="showRestaurants">
        <label class="form-check-label" for="restaurant-box">Restaurants</label>
      </div>
    </div>
    <div id="neighborhood-map"></div>
  </div>
</template>

<script>
import GooglePlacesApi from '../../../../lib/googlePlacesApi.js'

/* eslint-disable */
var restaurantSVG = [
'<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
         'x="0px" y="0px" viewBox="0 0 384 512" style="enable-background:new 0 0 384 512;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#363E4A;}',
        '.st1{fill:#FFFFFF;}',
'</style>',
'<path class="st0" d="M172.3,501.7C27,291,0,269.4,0,192C0,86,86,0,192,0s192,86,192,192c0,77.4-27,99-172.3,309.7',
        'C202.2,515.4,181.8,515.4,172.3,501.7L172.3,501.7z"/>',
'<path class="st1" d="M184.1,55.6c0.5,2.6,9.1,53.2,9.1,72.5c0,29.5-15.7,50.5-38.8,58.9l7.3,134.1c0.4,7.7-5.7,14.2-13.5,14.2h-36',
        'c-7.7,0-13.9-6.5-13.5-14.2l7.3-134.1C82.6,178.6,67,157.5,67,128.1c0-19.4,8.6-69.9,9.1-72.5c1.8-11.4,25.5-11.6,27,0.6v79.5',
        'c0.7,1.9,8.5,1.8,9,0c0.8-14.2,4.4-78.4,4.5-79.9c1.9-11.7,25.2-11.7,27,0c0.1,1.5,3.7,65.6,4.5,79.9c0.5,1.8,8.3,1.9,9,0V56.2',
        'C158.5,44,182.3,44.1,184.1,55.6z M251.2,216.5l-8.4,104.2c-0.7,7.9,5.6,14.6,13.5,14.6h31.5c7.5,0,13.5-6,13.5-13.5V60.5',
        'c0-7.4-6-13.5-13.5-13.5C241.3,47,163.1,147.5,251.2,216.5L251.2,216.5z"/>',
'</svg>'
].join('\n')

var schoolSVG = [
'<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
         'x="0px" y="0px" viewBox="0 0 384 512" style="enable-background:new 0 0 384 512;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#363E4A;}',
        '.st1{fill:#FFFFFF;}',
'</style>',
'<path class="st0" d="M172.3,501.7C27,291,0,269.4,0,192C0,86,86,0,192,0s192,86,192,192c0,77.4-27,99-172.3,309.7',
        'C202.2,515.4,181.8,515.4,172.3,501.7L172.3,501.7z"/>',
'<path class="st1" d="M343.5,130.7L203.7,87.8c-7.6-2.3-15.8-2.3-23.4,0L40.5,130.7c-11.8,3.6-11.8,19.2,0,22.8l24.4,7.5',
        'c-5.3,6.6-8.6,14.7-9,23.5c-4.8,2.8-8.2,7.8-8.2,13.7c0,5.4,2.8,9.9,6.9,12.9l-12.8,57.6c-1.1,5,2.7,9.8,7.8,9.8h28.1',
        'c5.1,0,8.9-4.8,7.8-9.8l-12.8-57.6c4.1-2.9,6.9-7.5,6.9-12.9c0-5.8-3.2-10.6-7.8-13.5c0.4-7.5,4.2-14.2,10.4-18.4l98,30.1',
        'c4.5,1.4,13.3,3.1,23.4,0l139.8-42.9C355.3,149.9,355.3,134.3,343.5,130.7L343.5,130.7z M208.4,211.8c-14.3,4.4-26.5,2-32.9,0',
        'l-72.7-22.3l-7.1,56.9c0,17.7,43.1,32.1,96.2,32.1s96.2-14.4,96.2-32.1l-7.1-56.9L208.4,211.8z"/>',
'</svg>'
].join('\n')

var houseSVG = ['<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
         'x="0px" y="0px" viewBox="0 0 288 417" style="enable-background:new 0 0 288 417;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#748096;}',
        '.st1{fill:#363E4A;}',
        '.st2{fill:#FCD990;}',
'</style>',
'<path class="st0" d="M105.5,277v112.4l26.5,23.7c5.7,5.1,18.3,5.1,24.1,0l26.5-23.7V277c-12.5,1.4-25.4,2.2-38.5,2.2',
        'S118,278.4,105.5,277z"/>',
'<circle class="st1" cx="144" cy="144" r="144"/>',
'<path class="st2" d="M140.8,89.9l-77.5,63.8v68.9c0,3.7,3,6.7,6.7,6.7l47.1-0.1c3.7,0,6.7-3,6.7-6.7v-40.2c0-3.7,3-6.7,6.7-6.7h26.9',
        'c3.7,0,6.7,3,6.7,6.7v40.2c0,3.7,3,6.7,6.7,6.7c0,0,0,0,0,0l47.1,0.1c3.7,0,6.7-3,6.7-6.7v-68.9l-77.4-63.7',
        'C145.3,88.4,142.7,88.4,140.8,89.9L140.8,89.9z M263.1,133.3L228,104.3V46.1c0-2.8-2.3-5-5-5h-23.5c-2.8,0-5,2.3-5,5v30.5',
        'l-37.6-30.9c-7.4-6.1-18.2-6.1-25.6,0L24.8,133.3c-2.1,1.8-2.4,5-0.7,7.1c0,0,0,0,0,0l10.7,13c1.8,2.2,4.9,2.5,7.1,0.7c0,0,0,0,0,0',
        'l98.8-81.4c1.9-1.5,4.6-1.5,6.4,0l98.8,81.4c2.1,1.8,5.3,1.5,7.1-0.7c0,0,0,0,0,0l10.7-13C265.6,138.2,265.3,135,263.1,133.3',
        'C263.2,133.3,263.1,133.3,263.1,133.3L263.1,133.3z"/>',
'</svg>'].join('\n')
/* eslint-enable */

export default {
  async mounted () {
    if (this.endPath === 'info') this.neighborhoodMap = this.initMap(document.getElementById('neighborhood-map'), 10)
  },
  props: {
    loc: Object
  },
  data () {
    return {
      neighborhoodMap: null,
      showSchools: false,
      schoolMarkers: [],
      showRestaurants: false,
      restaurantMarkers: []
    }
  },
  computed: {
    endPath () {
      return this.$route.params.endPath
    }
  },
  methods: {
    initMap (node, zoom) {
      var map = new window.google.maps.Map(node, {
        mapTypeControlOptions: {
          mapTypeIds: [window.google.maps.MapTypeId.ROADMAP]
        },
        center: this.loc,
        zoom: zoom,
        fullscreenControl: false,
        streetViewControl: false,
        styles: this.mapStyle
      })
      this.marker = new window.google.maps.Marker({
        position: this.loc,
        map: map,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(houseSVG),
          scaledSize: new window.google.maps.Size(40, 40)
        }
      })
      return map
    },
    createContentString (data) {
      var contentString = `
        <div class="container">
          <div class="row">
            <div class="col">
              <p>${data.name}</p>
            </div>
          </div>
        </div>`
      return contentString
    },
    async getPoiMarkers (poiString, map, icon) {
      var that = this
      var poiMarkers = []
      var pois = await GooglePlacesApi.googleSearchLatLong(document.getElementById('google-citation'), poiString, this.loc)
      pois.forEach((poi) => {
        var infoWindow = new window.google.maps.InfoWindow({
          content: that.createContentString(poi)
        })
        var marker = new window.google.maps.Marker({
          position: poi.geometry.location,
          map: map,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            scaledSize: new window.google.maps.Size(40, 40)
          }
        })
        marker.addListener('mouseover', function () {
          infoWindow.open(map, marker)
        })
        marker.addListener('mouseout', function () {
          infoWindow.close()
        })
        poiMarkers.push(marker)
      })
      return poiMarkers
    }
  },
  watch: {
    endPath: function (newPath, oldPath) {
      if (newPath === 'info') {
        this.$nextTick(async () => {
          this.schoolMarkers = []
          this.restaurantMarkers = []
          this.neighborhoodMap = this.initMap(document.getElementById('neighborhood-map'), 10)
          if (this.showSchools) {
            this.schoolMarkers = await this.getPoiMarkers('schools', this.neighborhoodMap, schoolSVG)
          }
          if (this.showRestaurants) {
            this.restaurantMarkers = await this.getPoiMarkers('restaurants', this.neighborhoodMap, restaurantSVG)
          }
        })
      }
    },
    showSchools: async function (newValue, oldValue) {
      if (newValue === true) {
        if (this.schoolMarkers.length === 0) {
          this.schoolMarkers = await this.getPoiMarkers('schools', this.neighborhoodMap, schoolSVG)
        } else {
          this.schoolMarkers.forEach((marker) => {
            marker.setVisible(true)
          })
        }
      }
      if (newValue === false) {
        this.schoolMarkers.forEach((marker) => {
          marker.setVisible(false)
        })
      }
    },
    showRestaurants: async function (newValue, oldValue) {
      if (newValue === true) {
        if (this.restaurantMarkers.length === 0) {
          this.restaurantMarkers = await this.getPoiMarkers('restaurants', this.neighborhoodMap, restaurantSVG)
        } else {
          this.restaurantMarkers.forEach((marker) => {
            marker.setVisible(true)
          })
        }
      }
      if (newValue === false) {
        this.restaurantMarkers.forEach((marker) => {
          marker.setVisible(false)
        })
      }
    }
  }
}
</script>

<style scoped>
#neighborhood-map {
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/Neighborhood.vue